import { useMemo } from "react";
import CompanyService from "../../../../services/CompanyService";
import { TranslationService } from "../../../../services/TranslationService";
import { TextEditorNumber } from "../../../shared/components/Editors";
import Dropdown from "../../../shared/components/Dropdown";
import { EditProps } from "../EditAction";
import { TextWithField, Checkbox, Field } from "./FieldHelpers";

export const InvoiceRequirements = ({ propGen }: EditProps) => {
  const cfg = propGen.num.notRequired("Mail_MinAmount");
  const mfg = propGen.num.notRequired("MaxAge");

  return (
    <>
      <TextWithField
        text={TranslationService.translate.MaxAging}
        fieldTitle={TranslationService.translate.Days}
      >
        {/* <input className="form-control" {...numEvent(propGen.num.notRequired("MaxAge"))} /> */}
        <TextEditorNumber
          defaultValue={mfg.defaultValue?.toString() ?? ""}
          onChange={(val) => {
            const num = parseFloat(String(val).replace(",", "."));
            mfg.onChange(Number.isNaN(num) ? undefined : num);
          }}
        />
      </TextWithField>
      <TextWithField
        text={TranslationService.translate.MinimumAmount}
        fieldTitle={CompanyService.GetDefaultCurrencySymbol()}
      >
        {/* <input className="form-control" {...numEvent(propGen.num.notRequired("Mail_MinAmount"))} /> */}
        <TextEditorNumber
          defaultValue={cfg.defaultValue?.toString() ?? ""}
          onChange={(val) => {
            const num = parseFloat(String(val).replace(",", "."));
            cfg.onChange(Number.isNaN(num) ? undefined : num);
          }}
        />
      </TextWithField>
    </>
  );
};

export const IncludeCustomerSheet = ({ data, setField }: EditProps) => {
  const reportTemplates = useMemo(
    () =>
      CompanyService.getReportExports()
        .filter((x) => x.Report === 2)
        .map((x) => ({
          value: x.ReportExportID,
          text: x.Name ?? TranslationService.translate.Default
        })),
    []
  );

  return (
    <>
      <Checkbox
        text={TranslationService.translate.IncludeCustomerSheet}
        defaultValue={data.IncludeClientData}
        onChange={setField("IncludeClientData")}
      />
      {data.IncludeClientData && (
        <div className="row">
          <Field title={TranslationService.translate.ClientDataReportTemplate}>
            <Dropdown
              items={reportTemplates}
              optionLabel={TranslationService.translate.Default}
              onChange={setField("ClientData_ReportExportID")}
              defaultValue={data.ClientData_ReportExportID}
            />
          </Field>
        </div>
      )}
    </>
  );
};
